import React from 'react'
import { Link } from "react-router-dom";
import Button from '../../../core/Button';
import Svg from '../Svg';

export default function LanguageSubHeader() {
    return (
        <div className='site-header subheader row g-0 align-items-center justify-content-end'>
            <div className="col-md-3"></div>
            <div className="col-md-6">
                <div className="language-sub-menu">
                    <ul>
                        <li>
                            <Link to="/admin/survey/create/language" className='active'>Default language</Link>
                        </li>
                        <li>
                            <Link to="/admin/survey/create/translation">Translation</Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="col-md-3">
                <div className="right-menu-wrap align-items-center d-flex justify-content-end">
                    {/* <div className="dropdown saving-dropdown d-flex">
                        <div className="dropdown savingdropdown">
                            <button className='d-flex align-items-center' type="button" id="dropdownCollection" data-bs-toggle="dropdown" aria-expanded="false">
                               <Svg name="auto-save" />
                                Auto saving
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownCollection">
                                <li><a className="dropdown-item" href="#">Option1</a></li>
                                <li><a className="dropdown-item" href="#">Option2</a></li>
                                <li><a className="dropdown-item" href="#">Option3</a></li>
                            </ul>
                        </div>

                    </div> */}
                    {/* <div className='preview-btn'>
                        < Button
                            type='default'
                            view='filled'
                            color='primary'
                            dense={false}
                            text='Preview'
                            icon={false}
                            rightIcon={false}
                            loading={false}
                            disabled={false}
                            fill={false}
                        />
                    </div> */}
                </div>
            </div>

        </div>
    )
}
